import apiClient from '../connections/api'

export default {
    getStatus: () => {
        return apiClient.get('/sync/status')
    },
    getStreamUrl: () => {
        const baseURL = apiClient.defaults.baseURL || ''
        const token = localStorage.getItem('token') || ''
        return `${baseURL}/sync/stream${token ? `?token=${encodeURIComponent(token)}` : ''}`
    },
    getSyncHistory: (page = 1, limit = 10) => {
        return apiClient.get(`/sync/history?page=${page}&limit=${limit}`)
    },
    syncAll: () => {
        return apiClient.post('/sync/all')
    },
    syncSites: () => {
        return apiClient.post('/sync/sites')
    },
    syncMachines: () => {
        return apiClient.post('/sync/machines')
    },
    syncReports: () => {
        return apiClient.post('/sync/reports')
    },
    syncPatterns: () => {
        return apiClient.post('/sync/patterns')
    },
    resetLock: () => {
        return apiClient.post('/sync/reset-lock')
    },
    abortSync: () => {
        return apiClient.post('/sync/abort')
    }
}
